class Slider {
    constructor(el, items, options) {
        this.slider = this;
        this.scope = el;
        this.items = items;
        this.count = options.count ? options.count : false;
        this.itemCount = items.childElementCount;
        this.splitXs = options.splitXs ? options.splitXs : false;
        this.prevButton = options.controls ? options.controls[0] : false;
        this.nextButton = options.controls ? options.controls[1] : false;
        this.gutter = 20;
        this.navContainer = options.navContainer;
        this.groupSlide = options.groupSlide ? options.groupSlide : false;
        this.buildSlider();
        this.indexButtons();
        this.navContainer !== null && this.navContainer !== undefined && this.tidyNav();
    }
    removeFocusableItems(items) {
        items.forEach(slide => {
            const tabIndexVal = slide.classList.contains(`tns-slide-active`) ? "" : -1;
            slide.querySelectorAll(`a, button`).forEach(link => link.tabIndex = tabIndexVal);
        });
    }
    buildSlider() {
        let options = {
            container: this.items,
            mouseDrag: true,
            controls: this.prevButton !== false,
            loop: false,
            gutter: this.gutter,
            prevButton: this.prevButton,
            nextButton: this.nextButton,
            nav: this.navContainer !== null,
            navContainer: this.navContainer,
            autoHeight: false,
            preventScrollOnTouch: false,
            onInit: () => this.removeFocusableItems(this.items.querySelectorAll(`.tns-item`)),
            responsive: {
                420: {
                  items: this.splitXs ? 2 : 1  
                },
                768: {
                    items: this.count ? this.count[0] : 2
                },
                1024: {
                    items: this.count ? this.count[1] : 3
                },
                1440: {
                    items: this.count ? this.count[2] : 3
                }
            }
        };
        this.sliderObject = tns(options);
        const doRemoveFocusableItems = () => this.removeFocusableItems(Array.from(this.sliderObject.getInfo().slideItems));
        this.sliderObject.events.on(`transitionStart`, doRemoveFocusableItems);
        this.resizeFunction = debounce(() => {
            this.sliderObject.updateSliderHeight();
        }, 500);
        this.sliderObject.events.on('newBreakpointEnd', doRemoveFocusableItems);
        window.addEventListener("resize", () => {
            this.resizeFunction();
        });
    }
    indexButtons() {
        if (this.prevButton) {
            this.prevButton.tabIndex = 0;
            this.enterButton(this.prevButton);
        }
        if (this.nextButton) {
            this.nextButton.tabIndex = 0;
            this.enterButton(this.nextButton);
        }
    }
    enterButton(button) {
        button.addEventListener("keypress", e => {
            if (e.code === "Enter") {
                setTimeout(() => document.querySelector('body').classList.add('keyboard-input'), 60);
            }
        });
    }

    tidyNav() {
        // Remove dead nav links
        const itemCount = this.items.childElementCount;
        const breakpoints = ["sm", "md", "lg"];
        const navItems = Array.from(this.navContainer.children);
        this.count.forEach((viewportCount, it) => {
            // Calculate the number of active navigation items (number of slides)
            const activeNavItems = Math.ceil(itemCount / viewportCount);
            navItems.forEach((navItem, i) => {
                // Hide nav items beyond the number of active navigation items
                navItem.removeAttribute("tabindex");
                if (i > activeNavItems) {
                    navItem.classList.add(`${breakpoints[it]}:hidden`);
                } else {
                    navItem.classList.remove(`${breakpoints[it]}:hidden`);
                }
                // hide null button
                if(i === activeNavItems){
                    if(breakpoints[it] === "sm"){
                        navItems[i].classList.add("sm:hidden");
                    }
                    if(breakpoints[it] === "md"){
                        navItems[i].classList.add("md:hidden");
                    }
                    if(breakpoints[it] === "lg"){
                        navItems[i].classList.add("xl:hidden");
                    }
                }
            });
        });
    }

}
